import { registerDevMenuItems, type ExpoDevMenuItem } from 'expo-dev-menu'
import { useEffect, useState } from 'react'

import { AppLayout } from '@/src/general/ui/layouts/AppLayout'

import { env } from '../config/env'
import { StorybookScreen } from '../general/ui/screens/StorybookScreen'

const isProduction = env.EXPO_PUBLIC_APP_VARIANT === 'prod'

export default () => {
  const [showStorybook, setShowStorybook] = useState(false)

  useEffect(() => {
    if (!isProduction) {
      const showStorybookDevMenuItems: ExpoDevMenuItem[] = [
        {
          name: '📕 Toggle storybook',
          callback: () => setShowStorybook((p) => !p),
          shouldCollapse: true,
        },
      ]
      void registerDevMenuItems(showStorybookDevMenuItems)
    }
  }, [])
  return showStorybook ? <StorybookScreen /> : <AppLayout />
}
